var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-table",
        {
          staticClass: "evaluation-table",
          attrs: { data: _vm.data, draggable: false, "show-detail-icon": "" },
        },
        [
          _c("b-table-column", {
            staticClass: "featured-column",
            attrs: { field: "index", label: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "router-link",
                      {
                        staticClass: "has-text-primary",
                        attrs: {
                          to: _vm.getEvaluationResumeLink(row),
                          "data-cy": `open-resume-${row.index}`,
                        },
                      },
                      [_vm._v(" Evaluación " + _vm._s(row.index) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "createdAt", label: "Fecha" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(" " + _vm._s(_vm.formatDate(row.createdAt)) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "creditAmount", label: "Solicitado" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatNumberByCountry(row.creditAmount)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "approvedCreditAmount", label: "Aprobado" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatNumberByCountry(row.approvedCreditAmount)
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "financingRatio", label: "Resultado" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "b-tag",
                      {
                        staticClass:
                          "result-icon-list is-light fixed-width-tag offer-result",
                        attrs: {
                          type: _vm.getResult(
                            row.financingRatio,
                            row.approvedCreditAmount
                          ).type,
                          "data-cy": `result-${row.index}`,
                          rounded: "",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                _vm.getResult(
                                  row.financingRatio,
                                  row.approvedCreditAmount
                                ).label
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "result", label: "Elegibilidad" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "b-tag",
                      {
                        staticClass:
                          "result-icon-list is-light fixed-width-tag eligibility-result",
                        attrs: {
                          type: _vm.getEvaluationResult(row.eligibility).type,
                          "data-cy": `eligibility-${row.index}`,
                          rounded: "",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                _vm.getEvaluationResult(row.eligibility).label
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "future", label: "Tipo" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(_vm.getType(row.future)) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "createdBy", label: "Evaluador" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("evaluator-avatar", {
                      attrs: {
                        "evaluator-id": row.createdBy?.userId,
                        "data-cy": row.createdBy?.userId
                          ? "manual-evaluation"
                          : "auto-evaluation",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "evidence", label: "Reporte" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm.showRatify(row)
                      ? _c(
                          "b-button",
                          {
                            staticClass: "mr-2 mb-1",
                            attrs: {
                              size: "is-small",
                              type: "is-danger",
                              "icon-left": "check-double",
                              rounded: "",
                              outlined: "",
                              "data-cy": `ratify-evaluation-${row.index}`,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.goResume(row)
                              },
                            },
                          },
                          [_vm._v(" Ratificar ")]
                        )
                      : _vm._e(),
                    row.evidence && row.status === "RATIFIED"
                      ? _c(
                          "b-button",
                          {
                            staticClass: "download-button",
                            attrs: {
                              size: "is-small",
                              "icon-left": "download",
                              tag: "a",
                              outlined: "",
                              href: row.evidence,
                              "data-cy": `download-button-${row.index}`,
                              download: "verificacion.pdf",
                              rounded: "",
                            },
                          },
                          [_vm._v(" Descargar ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }